import React from "react";
import { Route, Router, Routes } from "react-router-dom";
import Home from "../../pages/Home/Home";
import Paintings from "../../pages/Paintings/Paintings";
import AboutMe from "../../pages/AboutMe/AboutMe";
import ChildrenBooks from "../../pages/ChildrenBooks/ChildrenBooks";
import Drawings from "../../pages/Drawings/Drawings";
import Services from "../../pages/Services/Services";
import Contacts from "../../pages/Contacts/Contacts";
import "./css/Routs.css";
import ScrollTop from "../scrollTop/scrollTop";

const Routs = () => {
  return (
    <div class="margin-top-hv">
        <ScrollTop/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="about" element={<AboutMe />} />
          <Route path="books" element={<ChildrenBooks />} />
          <Route path="paintings" element={<Paintings />} />
          <Route path="drawings" element={<Drawings />} />
          <Route path="services" element={<Services />} />
          <Route path="contacts" element={<Contacts />} />
        </Routes>
    </div>
  );
};

export default Routs;
